import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import './i18n'; // Initialiser i18n
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: "https://ec792244a60283b1f4918959d80a5183@o4510405063933952.ingest.de.sentry.io/4510405070356560",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Gestion globale des erreurs non capturées
window.addEventListener('error', (event) => {
  Sentry.captureException(event.error, {
    tags: {
      type: 'uncaught_error',
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    },
    extra: {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    }
  })
})

// Gestion des promesses rejetées non gérées
window.addEventListener('unhandledrejection', (event) => {
  Sentry.captureException(event.reason, {
    tags: {
      type: 'unhandled_promise_rejection'
    },
    extra: {
      reason: event.reason,
      promise: event.promise
    }
  })
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
